import React, { forwardRef, useState } from 'react';
import Styles from './bundle.esm2.js';
import Backdrop from '../Backdrop/bundle.esm.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Modal = forwardRef((props, ref) => {
  const { className, footer, onClose = defaultFunction } = props;
  const { header, children, closeIcon, opened } = props;
  const { closeOnClickOutside = true, backdropConfig } = props;
  const { width, height, color } = props;
  const [internalOpened, setInternalOpened] = useState(false);
  const show = typeof opened === "undefined" ? internalOpened : opened;
  const onBackdropClicked = () => {
    var _a;
    if (!closeOnClickOutside)
      return;
    closeHandler();
    (_a = backdropConfig == null ? void 0 : backdropConfig.onClick) == null ? void 0 : _a.call(backdropConfig);
  };
  const closeHandler = () => {
    onClose();
    setInternalOpened(false);
  };
  if (!show)
    return null;
  return /* @__PURE__ */ React.createElement(Backdrop, __spreadProps(__spreadValues({
    onClick: onBackdropClicked,
    name: "Modal"
  }, backdropConfig), {
    opened: true
  }), /* @__PURE__ */ React.createElement(Styles, {
    className: `Modal ${className}`,
    width,
    height,
    color,
    ref
  }, header ? /* @__PURE__ */ React.createElement("header", {
    className: "Modal__header"
  }, header) : null, closeIcon ? /* @__PURE__ */ React.createElement("div", {
    className: "Modal__close-icon",
    onClick: closeHandler
  }, closeIcon) : null, /* @__PURE__ */ React.createElement("main", {
    className: "Modal__body"
  }, children), footer ? /* @__PURE__ */ React.createElement("footer", {
    className: "Modal__footer"
  }, footer) : null));
});
Modal.defaultProps = {
  className: "",
  onClose: defaultFunction,
  closeOnClickOutside: true
};

export { Modal as default };
//# sourceMappingURL=bundle.esm.js.map
